import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

/**
 * Displays formatted currencies
 *
 * <FormattedNumber> and formatNumber use the Intl.NumberFormat API.
 * Unforutnately we would like to display "incorrect" currencies for ambiguous
 * cases (eg: C$10 instead of $10) because we are less worried about how
 * Canadians write their own dollar amounts and more interested about re-assuring
 * our customers that they are being charged in their local currency.
 * There is no JS api for directly controlling the symbol used, so we can either
 * format currencies ourselves (bad idea) or "fix" them after the fact.
 */

// Dictionary of currency codes that we wish we could control the symbol.
const ambiguousCurrencies = {
  CAD: {
    symbol: /^\$/,
    disambiguateSymbol: 'C$',
  },
};

// Replace ambiguous currency symbols
const disambiguate = (formattedNumber, currencyCode) => {
  const options = ambiguousCurrencies[currencyCode] || {};
  return formattedNumber.replace(options.symbol, options.disambiguateSymbol);
};

const Currency = ({ amount, intl, currency }) => {
  const formattedCurrency = intl.formatNumber(amount, {
    currency,
    style: 'currency',
  });
  return <span>{disambiguate(formattedCurrency, currency)}</span>;
};

Currency.propTypes = {
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(Currency);
